// Requests API endpoints
export const getRequestsUrl = () => `/requests/list`;
export const getRequestTypesUrl = () => `/requests/types`;
export const getSegmentsUrl = () => `/requests/segments`;
export const createProspectUrl = () => `/customers/prospect`;
export const filterRequestsUrl = () => `/requests/filter`;

export const generateAccessUrl = (businessKey: string) =>
  `/admin/generate-customer-access?businessKey=${businessKey}`;

// Référentiels de l'écran de création de prospect personne morale.
export const incorporationCountriesUrl = () =>
  `/bank/countries/all?page=0&size=300`;
export const legalFormsForCountryUrl = (countryCode: string) =>
  `/customers/prospect/legal-forms/${encodeURIComponent(countryCode)}`;
